import { WizardStepStatus } from '../types';
import { NextStepAction, OpenStepAction, WizardStepsAction, WizardStepsActionType, WizardStepsState } from './types';

const openStep = (state: WizardStepsState, action: OpenStepAction) => {
  const panelToOpen = state.steps[action.payload.stepName];
  if (panelToOpen.status !== WizardStepStatus.Completed) {
    return state;
  }
  const steps = Object.keys(state.steps).reduce((acc, key: string) => {
    const stepName = key;
    return {
      ...acc,
      [stepName]: {
        ...state.steps[stepName],
        isOpen: false,
        status:
          state.steps[stepName].stepNumber > state.steps[action.payload.stepName].stepNumber
            ? WizardStepStatus.Inactive
            : WizardStepStatus.Completed,
      },
    };
  }, {});

  return {
    steps: {
      ...steps,
      [action.payload.stepName]: {
        ...panelToOpen,
        isOpen: true, // TODO: Is isOpen needed?
        status: panelToOpen.isOpen ? panelToOpen.status : WizardStepStatus.Active,
      },
    },
  };
};

const nextStep = (state: WizardStepsState, action: NextStepAction): WizardStepsState => {
  const nextStepNumber = state.steps[action.payload.currentStepName].stepNumber + 1;
  const steps = {
    ...state.steps,
    [action.payload.currentStepName]: {
      ...state.steps[action.payload.currentStepName],
      status: WizardStepStatus.Completed,
      isOpen: false,
    },
  };

  const nextStepName = Object.keys(state.steps).find(name => state.steps[name].stepNumber === nextStepNumber);

  if (nextStepName) {
    steps[nextStepName] = {
      ...steps[nextStepName],
      status: WizardStepStatus.Active,
      isOpen: true,
    };
  }

  return {
    steps,
  };
};

export const wizardStepsReducer = (state: WizardStepsState, action: WizardStepsAction): WizardStepsState => {
  switch (action.type) {
    case WizardStepsActionType.OPEN_STEP:
      return openStep(state, action);
    case WizardStepsActionType.NEXT_STEP:
      return nextStep(state, action);
    default:
      return state;
  }
};
